module.exports = __webpack_public_path__ + "img/step4b-mobile-en.b68f2e28.webp";